import { defineComponent, computed, ref } from 'vue';
export default defineComponent({
  props: {
    theme: {
      type: String,
      default: 'green'
    }
  },
  setup: function setup(props) {
    var showT = ref(false);

    var show = function show() {
      showT.value = true;
      setTimeout(function () {
        showT.value = false;
      }, 5000);
    };

    return {
      showT: showT,
      show: show
    };
  }
  /* created: function () {
    window.addEventListener('scroll', this.scroll)
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.scroll)
  },
  methods: {
    scroll: lodash.debounce(function () {
      console.log('scroll')
    }, 100)
  } */

});